import "./UpdateProfile.css";

const UpdateProfile = () => {
    return <></>;
};

export default UpdateProfile;
